import React from 'react';
import header from './header.jpg';
import {NavLink} from 'react-router-dom';
import CONSTANTS from '../../../../constants/constants';
import ContentTitle from '../../../ContentTitle/ContentTitle.js';
import ContentDescription from '../../../ContentDescription/ContentDescription.js';
import news_styles from './content.module.css';

const Content=(props)=>{
	let image_background=null,
		image_size=(props.feature===true?'':'resize=1&width=525');

	let styles={...news_styles};
	Object.keys(props.content_styles || {}).forEach(k=>{
		styles[k]=(styles[k]===undefined?'':styles[k]+' ')+props.content_styles[k];
	});
	Object.keys(props.layout_styles || {}).forEach(k=>{
		styles[k]=(styles[k]===undefined?'':styles[k]+' ')+props.layout_styles[k];
	});

	if(props.data.Metadata.preview_image!==undefined)
		image_background=<img alt="" className={props.content_styles.feature} src={window.global.content_hub.ASSETS+'/images/'+props.data.Metadata.preview_image+'?'+image_size}/>;
	else
		image_background=<img alt="" className={props.content_styles.feature} src={header}/>;
	
	return (
		<NavLink to={`${CONSTANTS.PAGE_CONTENT}/${props.data.ID}`} style={{width:'100%'}}>
			<div className={styles.container}>
				<div className={styles.image_container}>
					{image_background}
				</div>
				<div className={styles.content_container}>
					<ContentTitle title={props.data.Title} styles={styles}/>
					<ContentDescription description={props.data.Description} styles={styles} feature={props.feature}/>
				</div>
			</div>
		</NavLink>
	);
}

export default Content;